import { ERROR_MESSAGE_EMAIL_INCORRECT, ERROR_MESSAGE_INVALID_NAME } from 'types/error.type'
import {
  isEmail,
  isImage,
  isValidName,
  validateField,
  validateFieldDate,
  validateFieldNumber,
} from 'utils/validate.util'
import { z } from 'zod'
import { toEN } from './date.util'
import { SystemMessages } from './enums/system-message.enum'

export const addCustomIssue = (ctx: z.RefinementCtx, path: string[], message: string) => {
  ctx.addIssue({
    path,
    code: z.ZodIssueCode.custom,
    message: message,
  })
}

export const nameFieldSchema = z
  .string()
  .min(3, SystemMessages.MESSAGE_MIN_SIZE_3)
  .refine((field) => !isValidName(field), {
    message: ERROR_MESSAGE_INVALID_NAME,
  })

export const realNameFieldSchema = z.string().refine((field) => !isValidName(field), {
  message: ERROR_MESSAGE_INVALID_NAME,
})

export const realDateFieldSchema = z.preprocess(validateFieldDate, z.string()).transform(toEN)

export const emailFieldSchema = z.string().refine(isEmail, {
  message: ERROR_MESSAGE_EMAIL_INCORRECT,
})

export const selectFieldSchema = z
  .preprocess((field) => {
    return validateField(field)
  }, z.string())
  .refine((field) => field !== '0', {
    message: SystemMessages.MESSAGE_002,
  })

export const selectIdFieldSchema = z.preprocess((field) => {
  return validateFieldNumber(field)
}, z.string())

export const pictureFieldSchema = z.instanceof(File).refine((field) => isImage(field), {
  message: SystemMessages.MESSAGE_FILE_OR_SIZE_FORMAT,
})
